(function() {
  var bundle = document.getElementById('ff-bundle');
  if (!bundle) return;

  var buyButtons = document.querySelector('[class*="buy-buttons-block"]');
  if (buyButtons) {
    var sectionWrapper = bundle.closest('.shopify-section');
    buyButtons.parentNode.insertBefore(bundle, buyButtons.nextSibling);
    if (sectionWrapper && !sectionWrapper.children.length) {
      sectionWrapper.style.display = 'none';
    }
  }

  var content = document.getElementById('ff-bundle-content');
  var addBtn = bundle.querySelector('.ff-bundle__add');
  var colourBtns = bundle.querySelectorAll('.ff-bundle__colourway');
  var sizeBtns = bundle.querySelectorAll('.ff-bundle__size');

  var dataEl = document.getElementById('ff-bundle-data');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);

  var selectedJacket = null;
  var selectedSize = null;

  colourBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      colourBtns.forEach(function(b) { b.classList.remove('ff-bundle__colourway--active'); });
      btn.classList.add('ff-bundle__colourway--active');
      selectedJacket = btn.getAttribute('data-jacket');
      updateButton();
    });
  });

  sizeBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      sizeBtns.forEach(function(b) { b.classList.remove('ff-bundle__size--active'); });
      btn.classList.add('ff-bundle__size--active');
      selectedSize = btn.getAttribute('data-size');
      updateButton();
    });
  });

  function getBootVariantId() {
    var input = document.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if (input) return parseInt(input.value, 10);
    var params = new URLSearchParams(window.location.search);
    var v = params.get('variant');
    return v ? parseInt(v, 10) : null;
  }

  function updateButton() {
    var bootId = getBootVariantId();
    if (bootId && selectedJacket && selectedSize) {
      addBtn.disabled = false;
      addBtn.textContent = 'Add Foundry Kit to Cart';
    } else if (!bootId) {
      addBtn.disabled = true;
      addBtn.textContent = 'Select your boot size first';
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Select jacket colour & size';
    }
  }

  var observer = new MutationObserver(function() { updateButton(); });
  var formInput = document.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
  if (formInput) {
    observer.observe(formInput, { attributes: true, attributeFilter: ['value'] });
    formInput.addEventListener('change', updateButton);
  }

  document.addEventListener('change', function(e) {
    if (e.target.closest('variant-picker, [class*="variant"]')) {
      setTimeout(updateButton, 50);
    }
  });

  function removeStandaloneBootFromCart(bootId) {
    return fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var updates = {};
        cart.items.forEach(function(item) {
          if (item.variant_id === bootId && (!item.properties || !item.properties._bundle)) {
            updates[item.key] = 0;
          }
        });
        if (!Object.keys(updates).length) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      });
  }

  addBtn.addEventListener('click', function() {
    if (addBtn.disabled) return;

    var bootId = getBootVariantId();
    var jacketVariants = data.jackets[selectedJacket];
    var jacketId = jacketVariants ? jacketVariants[selectedSize] : null;
    var toteId = data.tote_variant_id;

    if (!bootId || !jacketId || !toteId) return;

    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';

    removeStandaloneBootFromCart(bootId)
      .then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: bootId, quantity: 1, properties: { '_bundle': 'Foundry Kit' } },
              { id: jacketId, quantity: 1, properties: { '_bundle': 'Foundry Kit' } },
              { id: toteId, quantity: 1, properties: { '_bundle': 'Foundry Kit' } }
            ]
          })
        });
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function() {
        addBtn.textContent = 'Added to Cart ✓';
        setTimeout(function() {
          window.location.href = '/cart';
        }, 600);
      })
      .catch(function() {
        addBtn.disabled = false;
        addBtn.textContent = 'Add Foundry Kit to Cart';
      });
  });

  updateButton();
})();

